import React from "react";
import dayjs from "dayjs";
import {Popconfirm} from "antd";
import {EditOutlined, DeleteOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

/**
 * Лёгкая плашка заметки для календаря.
 *
 * Props:
 * - note: { id, title, description?, date }  // date — ISO string/Date
 * - onClick?: (note) => void                  // option: click on chip
 * - className?: string
 */
const NoteChip = ({note, onClick, onEdit, onDelete, className = ""}) => {
    const {t} = useTranslation();

    return (
        <div>
            <div
                className={`
                group relative cursor-pointer rounded-lg border-l-4 shadow-sm transition-transform hover:scale-[1.01]
                bg-amber-50 border-l-amber-400 ${className}
              `}
                onClick={() => (onClick ? onClick(note) : onEdit?.(note))}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onClick ? onClick(note) : onEdit?.(note);
                    }
                }}
                role="button"
                tabIndex={0}
                title={dayjs(note?.date).isValid() ? dayjs(note.date).format("YYYY-MM-DD") : ""}
            >
                <div className="p-2">
                    <div className="flex items-center justify-between gap-2 mb-1">
                        <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-5 h-5 rounded bg-amber-200 text-amber-900">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path
                    d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1v4h4l-4-4zM8 11h8v2H8v-2zm0 4h8v2H8v-2z"/>
              </svg>
            </span>
                            <span className="text-xs font-semibold text-amber-900">Note</span>
                        </div>

                        {/* Hover-action */}
                        <div className="hidden group-hover:flex items-center gap-1">
                            <button
                                type="button"
                                className="px-2 py-1 text-xs rounded bg-white border border-amber-300 hover:bg-amber-100"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onEdit?.(note);
                                }}
                                data-no-dnd="true"
                                aria-label="Edit note"
                            >
                                <EditOutlined style={{fontSize: "14px", color: "#d97706"}}/>
                            </button>
                            <Popconfirm
                                title={t("publicationCalendar.noteModal.deleteCards.title")}
                                description={t("publicationCalendar.noteModal.deleteCards.description")}
                                okText={t("publicationCalendar.noteModal.buttons.delete")}
                                cancelText={t("publicationCalendar.noteModal.buttons.cancel")}
                                okButtonProps={{danger: true}}
                                onConfirm={(e) => {
                                    e?.stopPropagation?.();
                                    onDelete?.(note);
                                }}
                                onCancel={(e) => e?.stopPropagation?.()}
                            >
                                <button
                                    type="button"
                                    className="px-2 py-1 text-xs rounded bg-white border border-red-300 hover:bg-red-50"
                                    aria-label="Delete note"
                                    onMouseDown={(e) => e.stopPropagation()}
                                    onClick={(e) => e.stopPropagation()}
                                    data-no-dnd="true"
                                >
                                    <DeleteOutlined style={{fontSize: "14px", color: "#dc2626"}}/>
                                </button>
                            </Popconfirm>
                        </div>
                    </div>

                    <div className="text-sm font-medium text-gray-900 truncate">
                        {note?.title || "Note"}
                    </div>
                    {note?.description && (
                        <div className="mt-0.5 text-xs text-gray-700 line-clamp-2">
                            {note.description}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NoteChip;